module.exports = __webpack_public_path__ + "img/shape_wolf.c6ec5027.png";